module.exports = __webpack_public_path__ + "img/taikaixin.3d4ee858.gif";